import { functions } from "../firebase/config";
import { httpsCallable } from "firebase/functions";

// ✅ Proper Firebase Callable function usage with better error handling
export const assignDeliveryPartnerRole = async (uid) => {
  try {
    console.log("🔧 Calling assignDeliveryPartnerRole for UID:", uid);
    const setRole = httpsCallable(functions, "assignDeliveryPartnerRole");
    const result = await setRole({ uid });
    console.log("✅ assignDeliveryPartnerRole result:", result.data);
    return result.data;
  } catch (error) {
    console.error("❌ Error in assignDeliveryPartnerRole:", error);
    throw error;
  }
};

export const revokeDeliveryPartnerRole = async (uid) => {
  try {
    console.log("🔧 Calling revokeDeliveryPartnerRole for UID:", uid);
    const revokeRole = httpsCallable(functions, "revokeDeliveryPartnerRole");
    const result = await revokeRole({ uid });
    console.log("✅ revokeDeliveryPartnerRole result:", result.data);
    return result.data;
  } catch (error) {
    console.error("❌ Error in revokeDeliveryPartnerRole:", error);
    throw error;
  }
};

// ✅ Admin role assignment function
export const assignAdminRole = async (uid, email) => {
  try {
    console.log("🔧 Calling assignAdminRole for UID:", uid, "Email:", email);
    const setAdminRole = httpsCallable(functions, "assignAdminRole");
    const result = await setAdminRole({ uid, email });
    console.log("✅ assignAdminRole result:", result.data);
    return result.data;
  } catch (error) {
    console.error("❌ Error in assignAdminRole:", error);
    throw error;
  }
};
